/**
 * Mixin containing months and week array
 */
export const monthAndWeekMixin = {
  props: {
    currentYear: Number,
    currentMonth: Number
  },
  data() {
    return {
      months: [
        "jan",
        "feb",
        "mar",
        "apr",
        "may",
        "jun",
        "jul",
        "aug",
        "sep",
        "oct",
        "nov",
        "dec"
      ],
      days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ]
    };
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  },
  computed: {
    isCurrentMonth() {
      const today = new Date();
      return (
        today.getFullYear() === this.currentYear &&
        today.getMonth() + 1 === this.currentMonth
      );
    }
  }
};
